import React, { useContext, useEffect, useState } from 'react'
import FormSkel from '../../components/Modals/FormSkel'
import { LoaderContext } from '../../context/loader-context'
import axios from 'axios'
import { API_URL } from '../../config/config'
import { NotificationManager } from 'react-notifications'
import formHook from '../../hooks/form-hook'
import fetchMssqlApi from '../../hooks/fetchMSSQL-hook'
import schema from '../../util/schema.json'
import IndexedDBAsync from '../../db/IndexedDBAsync'
import IndexedDB from '../../db/IndexedDB'
import parseCookies from '../../util/parseCookies'
import setCookies from '../../util/setCookies'
import _ from 'lodash'

export default function MachinesFilterForm({
    selectedMachinesCount,
    machinesCount,
    handleClose,
    commitLogin,
}) {
    const { incrementRequests, decrementRequests } = useContext(LoaderContext)
    const [data, setData] = useState(null)
    const [summaryMachines, setSummariesMachines] = useState(machinesCount)
    const [isFirstLogin, setIsFirstLogin] = useState(true)
    const checkIsFirstLogin = () => {
        let jsonLoginFilter
        try {
            const stringFilter = parseCookies("loginFilter")
            if (stringFilter)
                jsonLoginFilter = stringFilter
            if (!Object.keys(stringFilter).length || !Object.keys(jsonLoginFilter).includes("Locations"))
                throw Error("Locations is empty")

        } catch (error) {
            return true
        }
        return false
    }

    // const {} = fetchMssqlApi
    const defaultParams = {
        Locations: [],
        Machines: [],
        Routes: [],
        Favourite: false,
        LastSeen: false,
    }
    const [chosenParams, setChosenParam] = useState(() => {
        setIsFirstLogin(checkIsFirstLogin())
        return defaultParams
    })
    // useEffect(() => localStorage.setItem("loginFilter", JSON.stringify(chosenParams)), [chosenParams])
    const { form, openForm, closeForm } = formHook()
    const db = new IndexedDB('dbV1', schema.schemas, 1)
    db.openDB()
    const closeModal = () => {
        closeForm()
    }
    const handleClick = (evt) => {
        evt.preventDefault()

        const type = evt.target.name
        switch (type) {
            case 'locations':
            case 'routes': {
                openForm(type)()
                break
            }
            case 'favourite':
                setChosenParam((prev) => ({
                    ...chosenParams,
                    Favourite: !prev.Favourite,
                }))
                break
            case 'lastSeen':
                setChosenParam((prev) => ({
                    ...chosenParams,
                    LastSeen: !prev.LastSeen,
                }))
                break
        }
    }
    const getData = () => {
        incrementRequests()
        incrementRequests()
        return axios
            .get(`${API_URL}/api/mobile/RoutesForLogin`)
            .then(({ data }) => {
                let jsonLoginFilter = parseCookies('loginFilter')
                if (isFirstLogin) {
                    jsonLoginFilter
                        ? jsonLoginFilter = { ...jsonLoginFilter, Locations: [...data.Locations].map(i => i.LocationId)}
                        : jsonLoginFilter = {Locations: [...data.Locations].map(i => i.LocationId)}
                    setData(jsonLoginFilter)
                }
                setCookies("loginFilter", JSON.stringify(jsonLoginFilter))

                setChosenParam(jsonLoginFilter)
                setData(data)
                return data
            })
            .catch((e) => {
                NotificationManager.error(
                    'Podczas pobierania danych wystąpił problem: ',
                    e
                )
            })
            .finally(() => decrementRequests())
    }
    const getSelectedLocations = () => {
        const summaryLocations = data?.Locations?.length || 0
        const chosenLocations = chosenParams?.Locations?.length || 0
        return `${chosenLocations}/${summaryLocations}`
    }
    const getSelectedRoutes = () => {
        const summaryRoutes = data?.Routes?.length || 0
        const chosenRoutes = chosenParams?.Routes?.length || 0
        return !chosenRoutes ? 'nie' : `${chosenRoutes}/${summaryRoutes}`
    }
    const toglleChoice = (checked, value, setState, type) => {
        if (checked == null) {
            checked = !chosenParams[type].includes(value);
        }

        if (checked) {
            setState((prev) => {
                if (!prev[type].includes(value)) {
                    return { ...prev, [type]: [...prev[type], value] };
                }
                return prev; 
            });
        } else {
            setState((prev) => ({
                ...prev,
                [type]: prev[type].filter((i) => i !== value),
            }));
        }
    };
    const selectAll = (type, key) => (evt) => {
        evt.preventDefault()
        setChosenParam((prev) => ({
            ...prev,
            [type]: data[type].map((i) => i[key]),
        }))
        closeModal()
    }
    const unselectAll = (type) => (evt) => {
        evt.preventDefault()
        setChosenParam((prev) => ({ ...prev, [type]: [] }))
        Array.from(
            document.querySelectorAll(
                `input[name="${type === 'Locations' ? 'location' : 'route'}"]`
            )
        ).map((i) => {
            i.checked = false
            return i
        })
    }
    const getFilteredMachines = (
        locations,
        routes,
        favourites,
        favourite,
        lastVisited,
        topCount
    ) =>
        axios
            .post(`${API_URL}/api/mobile/FilteredMachines`, {
                locations,
                routes,
                favourite,
                favourites,
                lastVisited,
                topCount,
            })
            .then((res) => {
                return res.data
            })
            .catch((e) => console.error(e))

    const getFilteredMachineProducts = (machineIds) =>
        axios
            .post(`${API_URL}/api/mobile/MachinesProducts`, {
                machineIds,
            })
            .then((res) => {
                return res.data;
            })
            .catch((e) => console.error(e))    

    const updatesSummaryMachinesQuantity = async (d = chosenParams) => {
        const data = d
        if (!data)
            NotificationManager.error("can`t parse data")
        let favourites
            , locations = data.Locations.map((i) => +i).join(',')
            , routes = data.Routes.map((i) => +i).join(',')
            , favourite = data.Favourite
            , lastVisited = data.LastSeen
        try {
            favourites = JSON.parse(localStorage.getItem('favouriteMachines'))
            if (!favourites || !favourites.length) throw Error()
            favourites = favourites?.join(",")
        } catch (e) {
            favourite = false
        }
        return axios
            .post(`${API_URL}/api/mobile/FilteredMachinesCount`, {
                locations: locations,
                routes: routes,
                favourite: favourite,
                favourites: favourites  ,
                lastVisited: lastVisited,
            })
            .then((res) => setSummariesMachines(res.data))
            .catch((e) => console.error(e))
    }
    const handleSubmit = (evt) => {
        evt.preventDefault()
        let data = chosenParams
        const dbAsync = new IndexedDBAsync('dbV1', schema.schemas, 1)
        let favourites
        let locations = data.Locations.map((i) => +i).join(','),
            routes = data.Routes.map((i) => +i).join(','),
            favourite = data.Favourite,
            lastVisited = data.LastSeen,
            topCount = selectedMachinesCount
        try {
            favourites = JSON.parse(localStorage.getItem('favouriteMachines'))
                .map((i) => +i)
                .join(',')
            if (!favourites || !favourite)
                throw Error()
        } catch (e) {
            favourite = false
            favourites = ''
        }
        incrementRequests()
        dbAsync
            .openDB()
            .then(() =>
                getFilteredMachines(
                    locations,
                    routes,
                    favourites,
                    favourite,
                    lastVisited,
                    topCount
                )
            )
            .then((data) => {
                if (!data)
                    throw Error('no machines found')
                return data
            })
            .then((m) => {
                m.forEach((i) => {
                    dbAsync
                        .addOrPutItem('machines', i, i.MachineId)
                        .catch((e) => console.error(e))
                })
                return m
        })
            .then((m) => getFilteredMachineProducts(m.map((i) => i.MachineId)))
            .then((products) => {
                products.forEach((i) => {
                    dbAsync
                        .addOrPutItem('machineProduct', i, i.MachineProductId)
                        .catch((e) => console.error(e))
                })
            })
            .then(() => {
                const { clientId } = JSON.parse(
                    localStorage.getItem('lastLogin')
                )
                commitLogin(clientId)
            })
            .finally(() => decrementRequests())
            .catch((e) => console.error(e))
    }
    
    useEffect(() => {
        let parsedData
        try {
            parsedData = parseCookies("loginFilter")
            if (!parsedData || !parsedData?.Locations)
                setIsFirstLogin(true)
        } catch (e) {
            console.error(e)
        }
        setChosenParam(prev => ({...prev, ...parsedData}))
        getData()
        .catch(e => console.error(e))
    }, [])
    useEffect(() => {
        !form && updatesSummaryMachinesQuantity()
    }, [form, chosenParams])
    useEffect(() => {
        chosenParams && setCookies('loginFilter', JSON.stringify(chosenParams))
    }, [chosenParams])
    const footer = (
        selectALl = () => {},
        unselctAll = () => {},
        handleSubmit = () => {}
    ) => (
        <div className="modal-footer bg-light d-flex justify-content-between">
            <div className="w-100 d-flex justify-content-between">
                <div>
                    <button
                        className="btn btn-primary mr-2"
                        onClick={selectALl}
                    >
                        Zaznacz wszystkie
                    </button>
                    <button className="btn btn-primary" onClick={unselctAll}>
                        Wyczyść
                    </button>
                </div>
                <div>
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Ok
                    </button>
                </div>
            </div>
        </div>
    )
    const showLocationsForm = (locations) => (
        <>
            <FormSkel
                headerText={'Lokalizacja'}
                noFooter={true}
                handleClose={closeModal}
                className="overflow-hidden"
                customFooter={footer(
                    selectAll('Locations', 'LocationId'),
                    unselectAll('Locations'),
                    (evt) => {
                        evt.preventDefault()
                        closeForm()
                    }
                )}
            >
                {locations &&
                    locations.map((i) => (
                        <div
                            className="d-flex align-items-center w-100"
                            key={i.LocationId}
                            onClick={() => toglleChoice(
                                null,
                                i.LocationId,
                                setChosenParam,
                                'Locations'
                            )}
                        >
                            <input
                                type="checkbox"
                                name="location"
                                id={i.LocationId}
                                checked={chosenParams.Locations.includes(i.LocationId)}
                                onChange={(evt) =>
                                    toglleChoice(
                                        evt.target.checked,
                                        i.LocationId,
                                        setChosenParam,
                                        'Locations'
                                    )
                                }
                                className="mr-3"
                            />
                            <label
                                className="m-0 form-check-label"
                                onClick={() => toglleChoice(
                                    null,
                                    i.LocationId,
                                    setChosenParam,
                                    'Locations'
                                )}
                            >
                                {i.Name}
                            </label>
                        </div>
                    ))}
            </FormSkel>
        </>
    );
    const showRoutesForm = (routes) => (
        <FormSkel
            headerText={'Trasa'}
            noFooter={true}
            handleClose={closeModal}
            customFooter={footer(
                selectAll('Routes', 'RouteId'),
                unselectAll('Routes'),
                (evt) => {
                    evt.preventDefault()
                    closeForm()
                }
            )}
        >
            {routes &&
                routes.map((i) => (
                    <div
                        className="d-flex align-items-center w-100"
                        htmlFor={i.RouteId}
                        key={i.RouteId}
                        onClick={(evt) =>
                        toglleChoice(
                            null,
                            i.RouteId,
                            setChosenParam,
                            'Routes'
                        )}
                    >
                        <input
                            type="checkbox"
                            name="route"
                            id={i.RouteId}
                            checked={chosenParams.Routes.includes(
                                i.RouteId
                            )}
                            onChange={(evt) =>
                                toglleChoice(
                                    evt.target.checked,
                                    i.RouteId,
                                    setChosenParam,
                                    'Routes'
                                )
                            }
                            className="mr-3"
                        />
                        <label htmlFor={i.RouteId} className="m-0"  onClick={(evt) =>
                        toglleChoice(
                            null,
                            i.RouteId,
                            setChosenParam,
                            'Routes'
                        )}>
                            {i.Name}
                        </label>
                    </div>
                ))}
        </FormSkel>
    )

    return (
        <FormSkel
            headerText="Wybierz maszyny do załadowania"
            handleClose={() => handleClose(chosenParams)}
            acceptForm={true}
            closeForm={() => handleClose(chosenParams)}
            disabledExitByClickingOutside={true}
            disableSubmit={!chosenParams?.Locations?.length}
        >
            <form onSubmit={handleSubmit} id="modal-form" autoComplete="off">
                {data && (
                    <div>
                        <div>Wymagane</div>
                        <hr
                            style={{ border: '1px solid gray' }}
                            className="mt-0"
                        />
                        <div
                            name="locations"
                            className="d-flex w-100 justify-content-between align-items-center"
                            onClick={handleClick}
                        >
                            <div>Lokalizacja</div>
                            <div>
                                <button
                                    name="locations"
                                    className={`btn btn-sm btn-${
                                        chosenParams?.Locations?.length
                                            ? 'success'
                                            : 'danger'
                                    }`}
                                >
                                    {getSelectedLocations()}
                                </button>
                            </div>
                        </div>
                        <hr className="m-1" />
                        <div>Opcjonalne</div>
                        <hr
                            style={{ border: '1px solid gray' }}
                            className="mt-0"
                        />
                        <div
                            name="routes"
                            className="d-flex w-100 justify-content-between align-items-center"
                            onClick={handleClick}
                        >
                            <div name="routes">Trasa</div>
                            <div>
                                <button
                                    className={`btn btn-sm btn-${
                                        chosenParams?.Routes?.length
                                            ? 'success'
                                            : 'warning'
                                    }`}
                                    name="routes"
                                >
                                    {getSelectedRoutes()}
                                </button>
                            </div>
                        </div>
                        <hr className="m-1" />
                        <div
                            name="favourite"
                            className="d-flex w-100 justify-content-between align-items-center"
                            onClick={handleClick}
                        >
                            <div name="favourite">Ulubione</div>
                            <div>
                                <button
                                    className={`btn btn-sm btn-${
                                        chosenParams?.Favourite
                                            ? 'success'
                                            : 'warning'
                                    }`}
                                    name="favourite"
                                >
                                    {chosenParams?.Favourite ? 'tak' : 'nie'}
                                </button>
                            </div>
                        </div>
                        <hr className="m-1" />
                        <div
                            name="lastSeen"
                            className="d-flex w-100 justify-content-between align-items-center"
                            onClick={handleClick}
                        >
                            <div name="lastSeen">Ostatnio odwiedzone</div>
                            <div>
                                <button
                                    className={`btn btn-sm btn-${
                                        chosenParams?.LastSeen
                                            ? 'success'
                                            : 'warning'
                                    }`}
                                    name="lastSeen"
                                >
                                    {chosenParams?.LastSeen ? 'tak' : 'nie'}
                                </button>
                            </div>
                        </div>
                        <hr className="m-1" />
                        <div>
                            <div className="d-flex w-100 justify-content-center">
                                Wybrałeś ładowanie {selectedMachinesCount}{' '}
                                maszyn z {summaryMachines} dostępnych
                            </div>
                            <div className="d-flex w-100 justify-content-center">
                                Wybierz warunki filtrowania dla bieżącej sesji
                            </div>
                        </div>
                    </div>
                )}
                {form &&
                    (function () {
                        switch (form) {
                            case 'locations':
                                return showLocationsForm(data?.Locations)
                            case 'routes':
                                return showRoutesForm(data?.Routes)
                            default:
                                closeForm()
                        }
                    })()}
            </form>
        </FormSkel>
        )       
}
